<script setup lang="ts">
import './assets/style.scss'
import { computed } from 'vue'

const props = defineProps({
  size: {
    type: Number,
    default: 40,
  },
  color: {
    type: String,
    default: 'primary',
  },
  width: {
    type: Number,
    default: 2,
  },
  wrapperHeight: {
    type: Number,
    default: 0,
  },
  full: {
    type: Boolean,
    default: false,
  },
})

const resultHeight = computed(() => {
  if (props.full) return '100%'

  return `${props.wrapperHeight || props.size + 20}px`
})
</script>

<template>
  <div class="v-preloader" :style="{ height: resultHeight }">
    <VProgressCircular :size :color :width indeterminate></VProgressCircular>
  </div>
</template>
